<template>
  <div class="hot_point_article_card">
    <el-row>
      <el-col :span="19">
        <div class="hot_point_article_card_title">
          <el-link :underline="false" @click="goToUrl">{{ title }}</el-link>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="hot_point_article_card_time">{{ pubTime }}</div>
        <div class="article_card_hot">&nbsp;</div>
      </el-col>
      <el-col :span="1">
        <el-link :underline="false" class="hotWriteBtn" @click="getHotPointArticle">
        </el-link>
      </el-col>
      <div style="clear:both"></div>
    </el-row>

  </div>
</template>

<script>

export default {
  name: 'hotPointCard',
  props: ['title', 'hotNum', 'source', 'url', 'pubTime', 'imgSrc', 'content', 'centerId', 'tag', 'isVip'],
  data () {
    return {
      loadSucc: true

    }
  },
  methods: {
    // 热点写作
    getHotPointArticle () {
      this.axios.postWithLoading('/webApi/v3/robot/writingResultByE_quick', { 'centerId': this.centerId, 'tag': this.tag }).then((response) => {
        this.$router.push({ path: '/newsEdit', query: { articleId: response.data.autoNewsId, from: 'hot' } })
      })
    },
    goToUrl () {
      if (this.isVip) {
        window.open(this.url, '_blank')
      } else {
        this.$store.commit('showPriceDialog');
      }
    }
  },
  mounted () {

  }
}
</script>
<style lang="less" scoped>
.hot_point_article_card {
  border: 0px;
  border-radius: 0px;
  box-shadow: none !important;
  margin: 20px 10px;

  .el-card__body {
    position: relative;
    padding: 0px !important;
  }

  .cover {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #000a;
    text-align: center;
    display: none;

    .el-link:first-child {
      height: 50%;
    }

    .el-link:last-child {
      height: 50%;
    }
  }
}

.hot_point_article_card:hover {
  .cover {
    display: block;
  }
}

.hotWriteBtn {
  position: relative;
  top: 0px;
  right: 10px;
  display: block;
}

.hotPointImg {
  width: 110px;
  height: 80px;
  margin: auto;
  margin-top: 10px;
  margin-bottom: 10px;
  display: block;
  border-radius: 5px;

  .el-image__inner {
    height: 100%;
  }
}

.xy_card {
  margin-top: 10px;
}

.card_img {
  width: 30%;
}

.card_img img {
  width: 100%;
}

.hot_point_article_card_time {
  display: inline-block;
  font-size: 0.7em;
  color: #989898;
}

.article_card_hot {
  display: inline-block;
  font-size: 0.7em;
  color: #989898;
  padding-left: 20px;
  text-align: right;
}

.card_red {
  background: red;
  width: 55px;
  height: 38px;
  font-size: 5px;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  right: -22px;
  top: -13px;
  text-align: center;
  padding-top: 22px;
  color: wheat;
}

.card_blue {
  background: blue;
  width: 55px;
  height: 38px;
  font-size: 5px;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  right: -22px;
  top: -13px;
  text-align: center;
  padding-top: 22px;
  color: wheat;
}

.add_btn>.el-icon-plus {
  font-size: 80px;
  font-weight: 900;
  color: #ccc;
  text-align: center;
}

.add_text {
  text-align: center;
  margin-top: 20px;
  font-size: 0.9em;
}
</style>



// WEBPACK FOOTER //
// src/components/hot_point_card.vue